<template>
    <div class="position-relative component">
        <div class="simplified-title text-center mb-5">
            <h1 v-html="trans(`general.space_setup.add_first_class`)"></h1>
        </div>
        <div class="d-flex justify-content-center align-items-start gap-3" v-if="model">
            <img class="mt-1" :src="`/img/class-icons/${model.color}-${model.icon}.svg`">

            <div style="width: 100%; max-width: 330px;">
                <basic-input
                    style="width: 100%;"
                    v-model="model.name"
                    :label="trans('general.space_setup.classes.group_name')"/>

                <class-level-select
                    class="mt-3"
                    ref="levelSelect"
                    v-model="selectedGroupLevel"
                    :allow-new="false"
                    :simple="true"
                    background="bg-transparent"/>
            </div>
        </div>

        <setup-footer ref="setupFooter" :step="step" v-on="$listeners" :next-disabled="!model"/>
    </div>
</template>

<script>
import BasicButton from "../../../theme/atoms/BasicButton.vue";
import SetupFooter from "../molecules/SetupFooter.vue";
import axios from "axios";
import BasicInput from "../../../theme/atoms/BasicInput.vue";
import {handleErrors} from "../../../services/ErrorHandler";
import {eventBus} from "../../../services/EventBus";
import ClassLevelSelect from "../../../modules/Groups/molecules/ClassLevelSelect.vue";

export default {
    name: "SetupClass",
    props: {
        done: {
            default: false,
        },
        step: {
            type: Number
        }
    },
    components: {BasicInput, SetupFooter, BasicButton, ClassLevelSelect},
    data() {
        return {
            model: null,
            selectedGroupLevel: [],
        }
    },
    watch: {
        model: {
            handler: function () {
                this.saveClassName();
            },
            deep: true
        },
        selectedGroupLevel: {
            handler: function () {
                this.saveGroupData();
            },
            deep: true
        }
    },
    methods: {
        saveClassName: _.debounce(function () {
            this.saveGroupData();
        }, 1000),

        saveGroupData() {
            let formData = new FormData();
            formData.append('class_id', this.model.id);
            formData.append('name', this.model.name);

            if(this.selectedGroupLevel.length > 0) {
                formData.append('space_setting_id', this.selectedGroupLevel[0].id);
            }

            axios.post(`/classes/save-group-and-assign-teachers`, formData).then(() => {}).catch(error => {handleErrors(error)});
        },

        getOrCreateFirstClass() {
            axios.get('/classes/first-or-create').then(response => {
                const firstClass = response.data.data;
                this.selectedGroupLevel = firstClass.level;
                this.model = firstClass;

                this.$emit('stepDone');
                eventBus.$emit('reloadClasses');
            });
        },
    },
    mounted() {
        if (this.done) {
            this.$emit('stepDone');
        }
        this.getOrCreateFirstClass();
    }
}
</script>
